var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{class:_vm.$style.root},[_c('ul',{class:_vm.$style.list},_vm._l((_vm.links),function(link,index){return _c('li',{key:index,class:_vm.$style.item},[(link.path)?[_c('router-link',{class:_vm.$style.link,attrs:{"to":link.path}},[_vm._v(_vm._s(link.name))])]:[_vm._v("\n        "+_vm._s(link.name)+"\n      ")]],2)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ee23334","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Breadcrumbs.vue
// module id = null
// module chunks = 